/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
import AnalyticsWebClient from './analyticsWebClient';
import {
	aliasType,
	apdexType,
	envType,
	eventType,
	groupType,
	originTracingType,
	originType,
	perimeterType,
	platformType,
	productEmbedType,
	tenantType,
	userType,
} from './analyticsWebTypes';
import DwellTimeHelper from './dwellTimeHelper';
import DwellTimeHelperWithBrowserInteraction from './DwellTimeHelperWithBrowserInteraction';
import { CompressionRule, StopLowPriorityEventDelayReason } from './eventDelay';
import { ResilienceMechanism } from './resilienceQueue';
import { STARGATE_PROXY_PATH } from './selectHost';
import TypeAheadHelper from './typeAheadHelper';

export type {
	OperationalEventPayload,
	ProductInfoType,
	ScreenEventPayload,
	SettingsType,
	TrackEventPayload,
	UIEventPayload,
} from './types';

export {
	AnalyticsWebClient as default,
	apdexType,
	envType,
	eventType,
	originType,
	platformType,
	tenantType,
	userType,
	originTracingType,
	// Helpers
	TypeAheadHelper,
	DwellTimeHelper,
	DwellTimeHelperWithBrowserInteraction,
	CompressionRule,
	ResilienceMechanism,
	StopLowPriorityEventDelayReason,
	STARGATE_PROXY_PATH,
	perimeterType,
	aliasType,
	groupType,
	productEmbedType,
};
